export default __webpack_public_path__ + "images/FK.30b0e08.png";